<app-header></app-header>
<div class="dynamic-height overflow-y-auto lg:pt-[70px] sm:pt-[79px] pt-[70px]">
    <router-outlet></router-outlet>
</div>